import { ELanguages } from 'scw-digital-boards-widgets';
import { IWorkspaceModules } from '../../pages/settings/dashboards/dashboards.interface';
import { TDecimalSeparator, TThousandSeparator } from '../../utilities/number-format-utilities.service';
import { ELoadStatus } from '../state.interface';

export interface IUserState {
  getCurrentUserStatus: ELoadStatus;
  user: ICurrentUser | null;
}

export interface IUser {
  client: string;
  configuration: IUserConfiguration;
  dfUserConfiguration: IDfUserConfiguration;
  email: string;
  id: number;
  isActive: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  name: string;
}

export enum EUserTheme {
  dark = 'dark',
  light = 'light',
}

export interface IUserConfiguration {
  theme?: EUserTheme;
}

export interface ICurrentUser extends IUser {
  authorizations: IRequestUserAuthorizations;
  moduleUrls: {
    actionTrackerBackendUrl: string;
    actionTrackerFrontendUrl: string;
    oeeTrackerBackendUrl: string;
    oeeTrackerFrontendUrl: string;
  };
}

export interface IEditDto {
  isActive?: boolean;
  isAdmin?: boolean;
  isSuperAdmin?: boolean;
  name?: string;
  configuration?: IUserConfiguration;
}

export interface IRequestUserAuthorizations {
  adminDashboardIds: number[] | -1;
  dashboardIds: number[] | -1;
  workspaceIds: number[] | -1;
  workspaceModules: IWorkspaceModules;
}

export type TBulkEditUser = Partial<IUser> & { id: number };

export interface IEditUser {
  dto: IEditDto;
  id: number;
}

export interface IDfUserConfiguration {
  dateFormat: string;
  decimalSeparator: TDecimalSeparator;
  language: ELanguages;
  locale: string;
  thousandSeparator: TThousandSeparator;
  timezone: string;
  decimalScaleLimit: number;
  virtualFlags: IDfUserConfigurationVirtualFlags;
}

export interface IDfUserConfigurationVirtualFlags {
  oeeCalculationBasis: number;
  oeeBaseType: number;
}
